import apiClient from "./Api";

export const processArea = async (layer_uuid, geometry) => {
  const response = await apiClient.post(
    `layers/carbon_sink/process/${layer_uuid}`,
    {
      geometry,
    }
  );
  return response.data;
};

export const processAreaSpain = async (layer_uuid, geometry) => {
  const response = await apiClient.post(
    `layers/carbon_sink/process/es/${layer_uuid}`,
    {
      geometry,
    }
  );
  return response.data;
};

export const processAreaPortugal = async (layer_uuid, geometry) => {
  const response = await apiClient.post(
    `layers/carbon_sink/process/pt/${layer_uuid}`,
    {
      geometry,
    }
  );
  return response.data;
};

export const changeCategory = async (layer_uuid, geometry, new_category) => {
  const response = await apiClient.post(
    `layers/carbon_sink/difference/${layer_uuid}/${new_category}`,
    {
      geometry,
    }
  );
  return response.data;
};

export const getCarbonHourlyQuotes = async () => {
  const response = await apiClient.get("core/carbon_market_quotes/hourly-euro");
  return response.data;
};

export const getCarbonDailyQuotes = async () => {
  const response = await apiClient.get("core/carbon_market_quotes/daily-euro");
  return response.data;
};

export const downloadCarbonSinkDoc = async (country, lang) => {
  // country: "spain" | "portugal"
  // lang: "en" | "pt" | "sp" (puedes usar "es" en el backend como alias de "sp")
  const response = await apiClient.get(
    `layers/docs/carbon_sink/${encodeURIComponent(country)}/${encodeURIComponent(lang)}`,
    { responseType: "blob" }
  );

  // intenta sacar el nombre del archivo del header Content-Disposition
  let filename = `carbon_sink_methodology_${country}_${lang}.pdf`;
  const cd =
    response.headers?.["content-disposition"] ||
    response.headers?.get?.("content-disposition");
  if (cd) {
    const match = /filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/i.exec(cd);
    const raw = decodeURIComponent(match?.[1] || match?.[2] || "");
    if (raw) filename = raw;
  }

  return { blob: response.data, filename };
};
